module.exports = __webpack_public_path__ + "img/fin_04_相框与树苗.1ec75629.jpg";